import type { AnalyticsEventPayload } from '@atlaskit/analytics-next/AnalyticsEvent';

import { filterCommonAttributes } from '../ai-answer-dialog/analytics-helpers';
import type { commonAttributesType } from '../ai-answer-dialog/types';
import type { PersonKnowledgeCardVariant } from './on-person-knowledge-card-loaded';

type FailedDataset = 'collaborators' | 'recentWork' | 'reportingLines';

export const onKnowledgeCardPartialDegradation = (
	props: commonAttributesType & {
		failedDatasets: readonly FailedDataset[];
		personCardVariant?: PersonKnowledgeCardVariant;
	},
): AnalyticsEventPayload => ({
	action: 'shown',
	actionSubject: 'aiAnswerPartialDegradation',
	source: props.source,
	eventType: 'track',
	attributes: {
		...filterCommonAttributes(props),
		cloudId: props.cloudId,
		...(props.personCardVariant !== undefined && { personCardVariant: props.personCardVariant }),
		failedDatasets: [...new Set(props.failedDatasets)].sort(),
	},
});
